var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_333324937487628597463343642416254075131",
    d: "M27.001 17.673l-.136-.453-2.605-.701c.016-.254.023-.509.023-.766 0-3.263-1.304-6.377-3.578-8.542l-1.062 1.287c1.933 1.839 3.04 4.483 3.04 7.255 0 .114-.001.227-.006.34l-1.69-.455c-.025-1.784-.616-3.516-1.672-4.891L18.08 11.84c.733.955 1.18 2.132 1.283 3.36l-1.723-.463c-.186-.844-.601-1.596-1.17-2.174l2.621-9.823-.296-.354C17.526.87 15.655 0 13.664 0c-1.991 0-3.862.87-5.132 2.387l-.297.354.74 2.77c-.58.308-1.138.674-1.666 1.099-1.784 1.433-3.129 3.475-3.787 5.75l1.528.51c.727-2.512 2.323-4.516 4.372-5.682L9.905 9c-.63.405-1.206.912-1.704 1.51l1.193 1.146c.292-.351.619-.662.971-.928l.49 1.837c-.565.575-.978 1.322-1.165 2.161l-1.726.46c.06-.71.232-1.395.515-2.042l-1.449-.73c-.44 1.008-.672 2.085-.689 3.203L.459 17.18l-.137.453c-.591 1.94-.36 4.116.632 5.97.992 1.855 2.626 3.164 4.484 3.591l.433.1 1.87-2.072c1.74 1.259 3.8 1.94 5.923 1.94.732 0 1.464-.08 2.175-.24l-.326-1.683c-.604.135-1.226.203-1.85.203-1.743 0-3.389-.54-4.784-1.482l1.21-1.342c1.058.639 2.278 1.003 3.575 1.003v-1.72c-.861 0-1.678-.205-2.41-.573l1.236-1.37c.371.12.765.185 1.174.185.404 0 .794-.063 1.163-.182l6.6 7.355.434-.098c1.858-.422 3.496-1.726 4.493-3.578.997-1.851 1.233-4.027.647-5.968zm-15.824-1.92c0-1.474 1.115-2.673 2.487-2.673 1.371 0 2.487 1.199 2.487 2.673 0 1.473-1.116 2.672-2.487 2.672-1.372 0-2.487-1.199-2.487-2.672z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_210608805879765663278287572680040469534",
    d: "M-2.803 -3.152H30.118999999999996V30.469H-2.803z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_190890654304318359543922507168003387313",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64 -267) translate(48 259) translate(16 8) translate(2.341 2.341)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_179155656227512319200603455120749532938",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_333324937487628597463343642416254075131"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_333324937487628597463343642416254075131"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_179155656227512319200603455120749532938)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_210608805879765663278287572680040469534"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_190890654304318359543922507168003387313)",
    xlinkHref: "#hinava_random_uuid_210608805879765663278287572680040469534"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.19f0b1efdb05eba57b2d6095d7c74620.svg";
export { ForwardRef as ReactComponent };